import Header from "../components/Header";
import { saveShippingAddress } from "./../redux/Actions/CartActions";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

const GHN_TOKEN = "31a64742-5e13-11f0-90c0-72fa78440389";
const GHN_BASE_URL = "https://online-gateway.ghn.vn/shiip/public-api";

const ShippingScreen = ({ history }) => {
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;

  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);

  const [provinceId, setProvinceId] = useState(shippingAddress?.saveData?.provinceId || "");
  const [districtId, setDistrictId] = useState(shippingAddress?.saveData?.districtId || "");
  const [wardCode, setWardCode] = useState(shippingAddress?.saveData?.wardCode || "");
  const [address, setAddress] = useState(shippingAddress?.saveData?.address || "");
  const [phone, setPhone] = useState(shippingAddress?.saveData?.phone || "");

  const [loadingProvinces, setLoadingProvinces] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingWards, setLoadingWards] = useState(false);

  const dispatch = useDispatch();

  // Load provinces
  useEffect(() => {
    setLoadingProvinces(true);
    axios.get(`${GHN_BASE_URL}/master-data/province`, { headers: { token: GHN_TOKEN } })
      .then(res => setProvinces(res.data.data || []))
      .catch(console.error)
      .finally(() => setLoadingProvinces(false));
  }, []);

  // Reset district & load districts
  useEffect(() => {
    if (provinceId) {
      setDistrictId("");
      setWards([]);
      setWardCode("");
      setLoadingDistricts(true);
      axios.post(`${GHN_BASE_URL}/master-data/district`,
        { province_id: parseInt(provinceId) },
        { headers: { token: GHN_TOKEN } }
      )
        .then(res => setDistricts(res.data.data || []))
        .catch(console.error)
        .finally(() => setLoadingDistricts(false));
    } else {
      setDistricts([]);
    }
  }, [provinceId]);

  // Reset ward & load wards
  useEffect(() => {
    if (districtId) {
      setWardCode("");
      setLoadingWards(true);
      axios.post(`${GHN_BASE_URL}/master-data/ward`,
        { district_id: parseInt(districtId) },
        { headers: { token: GHN_TOKEN } }
      )
        .then(res => setWards(res.data.data || []))
        .catch(console.error)
        .finally(() => setLoadingWards(false));
    } else {
      setWards([]);
    }
  }, [districtId]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!provinceId || !districtId || !wardCode || !address || !phone) {
      alert("Vui lòng nhập đầy đủ thông tin");
      return;
    }

    if (!/^\d{8,12}$/.test(phone)) {
      alert("Số điện thoại không hợp lệ (8-12 chữ số)");
      return;
    }

    const province = provinces.find(p => p.ProvinceID.toString() === provinceId)?.ProvinceName || "";
    const district = districts.find(d => d.DistrictID.toString() === districtId)?.DistrictName || "";
    const ward = wards.find(w => w.WardCode === wardCode)?.WardName || "";

    const fullAddress = `${address}, ${ward}, ${district}, ${province}`;

    dispatch(saveShippingAddress({
      address: fullAddress,
      city: phone,
      postalCode: `(${provinceId},${districtId},${wardCode})`,
      country: 'VN',
      saveData: { provinceId, districtId, wardCode, address, phone }
    }));

    history.push("/payment");
  };

  return (
    <>
      <Header />
      <div style={styles.container}>
        <h3 style={styles.title}>📦 Địa chỉ giao hàng</h3>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="tel"
            placeholder="📞 Số điện thoại"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            required
            style={styles.input}
          />
          <input
            type="text"
            placeholder="🏠 Địa chỉ cụ thể (số nhà, đường...)"
            value={address}
            onChange={e => setAddress(e.target.value)}
            required
            style={styles.input}
          />

          <select value={provinceId} onChange={e => setProvinceId(e.target.value)} required style={styles.select} disabled={loadingProvinces}>
            <option value="">{loadingProvinces ? "Đang tải tỉnh/thành..." : "🗺️ Chọn tỉnh/thành phố"}</option>
            {provinces?.map(p => (
              <option key={p.ProvinceID} value={p.ProvinceID}>{p.ProvinceName}</option>
            ))}
          </select>

          <select value={districtId} onChange={e => setDistrictId(e.target.value)} required disabled={!provinceId || loadingDistricts} style={styles.select}>
            <option value="">{loadingDistricts ? "Đang tải quận/huyện..." : "Chọn quận/huyện"}</option>
            {districts?.map(d => (
              <option key={d.DistrictID} value={d.DistrictID}>{d.DistrictName}</option>
            ))}
          </select>

          <select value={wardCode} onChange={e => setWardCode(e.target.value)} required disabled={!districtId || loadingWards} style={styles.select}>
            <option value="">{loadingWards ? "Đang tải phường/xã..." : "Chọn phường/xã"}</option>
            {wards?.map(w => (
              <option key={w.WardCode} value={w.WardCode}>{w.WardName}</option>
            ))}
          </select>

          <button
            type="submit"
            style={styles.button}
            disabled={loadingProvinces || loadingDistricts || loadingWards}
          >
            Xác nhận
          </button>
        </form>
      </div>
    </>
  );
};

const styles = {
  container: {
    maxWidth: 400,
    margin: "40px auto",
    padding: 20,
    border: "1px solid #ddd",
    borderRadius: 10,
    background: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
  },
  title: {
    textAlign: "center",
    marginBottom: 20
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 12
  },
  input: {
    padding: 10,
    fontSize: 16,
    border: "1px solid #ccc",
    borderRadius: 6
  },
  select: {
    padding: 10,
    fontSize: 16,
    border: "1px solid #ccc",
    borderRadius: 6
  },
  button: {
    padding: 12,
    fontSize: 16,
    background: "#28a745",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: "pointer"
  }
};

export default ShippingScreen;
